import { render, staticRenderFns } from "./TosDialog.vue?vue&type=template&id=7b455140&scoped=true"
import script from "./TosDialog.vue?vue&type=script&lang=js"
export * from "./TosDialog.vue?vue&type=script&lang=js"
import style0 from "./TosDialog.vue?vue&type=style&index=0&id=7b455140&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b455140",
  null
  
)

export default component.exports